export enum EVideoEventType {
  Play = 'play',
  Pause = 'pause',
  LoadedData = 'loadeddata',
  CanPlay = 'canplay',
  Error = 'error',
  Click = 'click',
  StateChange = 'stateChange'
}
